import { Helmet } from "react-helmet-async";

const SITE_URL = "https://brawinfo.com";
const OG_IMAGE = `${SITE_URL}/braw-logo.png`;

export default function Seo({ title, description, path = "/", image = OG_IMAGE, type = "website" }) {
  const fullTitle = title || "B-Raw — Tasty & Crunchy Snacks | Made in Sirsa";
  const desc = description || "B-Raw brings you hand-crafted, FSSAI-certified snacks from Sirsa. 5 signature flavours at ₹10 a pack — real ingredients, honest pricing, small-batch made in Bharat.";
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="B-Raw" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="B-Raw — Tasty & Crunchy" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
